<template>
  <v-main>
    <v-container class="o-container">
      <app-load v-if="load" class="mt-4"></app-load>
      <div v-if="!article.title && !load" class="my-4 text-center">
        <small>文章不存在 :(</small>
      </div>
      <v-card v-if="!load && article.title" flat tile class="px-0">
        <v-img
          width="100%"
          height="45vh"
          :src="article.banner"
        ></v-img>
        <v-divider></v-divider>
        <div class="pa-4">
          <div>
            <h1 class="primary--text">{{ article.title }}</h1>
          </div>
          <div class="pt-2 d-flex flex-row align-center">
            <v-chip small>{{ article.type }}</v-chip>
            <v-chip small class="ml-2">{{ article.cat }}</v-chip>
            <div class="subtitle-1">
              <v-icon small class="ml-8 mr-1">mdi-fountain-pen-tip</v-icon>{{ article.author }}
              <v-icon small class="ml-8 mr-1">mdi-calendar-text</v-icon>{{ date }}
            </div>
          </div>
        </div>
        <v-divider></v-divider>
        <div class="pa-4">
          <article v-html="article.trixText"></article>
          <div class="mt-16 share-btn">
            <ShareNetwork
              v-for="(b, idx) in share"
              :key="idx"
              :network="b.network"
              :url="url"
              :title="article.title"
              :quote="article.title"
              :hashtags="`${article.type}`"
              class="mr-2"
            >
              <v-btn
                  :color="b.color"
                  dark
                  label
                >
                  <font-awesome-icon
                    :icon="['fab', b.icon]"
                    size="2x"
                    class="mr-2"
                  ></font-awesome-icon>
                  分享到 {{ b.network }}
              </v-btn>
            </ShareNetwork>
          </div>
        </div>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebookSquare, faLine } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faFacebookSquare, faLine)

import apiArticle from '@/assets/js/db/api/article';

export default {
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    'app-load': () => import('../components/app/load')
  },
  data: () => ({
    load: true,
    article: {},
    share: [
      { network: 'Facebook', color: '#1676F2', icon: 'facebook-square' },
      { network: 'Line', color: '#00C300', icon: 'line' }
    ]
  }),
  computed: {
    date() {
      const dd = this.article.createdAt;
      return !dd ? '' : dd.slice(0,10);
    },
    url() {
      return `${window.location.origin}${this.$route.fullPath}`;
    }
  },
  watch:{
    $route() {
      this.initPage();
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    async initPage() {
      this.load = true;
      await this.getArticle();
      this.load = false;
    },
    async getArticle() {
      await apiArticle.get(this.$route.params.id)
        .then(({ data }) => {
          this.article = data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
}
</script>